export default {
  methods: {
    // 打印
    print () {
    }
  }
}
